import clsx from "clsx";
import Image from "next/image";
import Link from "next/link";

import IconDocument from "../../assets/icons/icon-document.svg";

import AddressLine from "../../components/address-line";

import styles from "./location-list-item.module.scss";

export default function LocationListItem({
  location,
  large,
  showBrochure = false
}) {
  return (
    <div
      className={clsx(
        styles.LocationListItem,
        large && styles.LocationListItemLarge
      )}
    >
      <div className={styles.LocationImage}>
        <Link href={`/locations/${location?.slug}`} passHref>
          <a>
            <Image
              src={location.featuredImage.url}
              alt={location.featuredImage.description}
              layout="responsive"
              width="255"
              height="255"
              objectFit="cover"
            />
          </a>
        </Link>
      </div>
      <Link href={`/locations/${location?.slug}`} passHref>
        <a>
          <h3>{location.name}</h3>

          <p>
            <AddressLine location={location} />{" "}
          </p>
        </a>
      </Link>

      {showBrochure && location?.document && (
        <a
          href={location.document.url}
          target="_blank"
          rel="noreferrer"
          className={styles.Brochure}
        >
          <div className="flex flex-row justify-start items-center my-1">
            <IconDocument role="presentation" className={styles.BrochureIcon} />
            <p>Open Building Brochure</p>
          </div>
        </a>
      )}
    </div>
  );
}
